/* <kg-copy data-text="…" data-copied="Kopiert">: der Button darin kopiert den Text in die Zwischenablage und zeigt kurz „Kopiert“ (Klasse is-copied, Label in [data-copy-label]). */

class KgCopy extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      if (event.target.closest('button')) this.copy();
    });
  }

  async copy() {
    const text = this.dataset.text || '';
    const label = this.querySelector('[data-copy-label]');
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      /* Zwischenablage gesperrt: Text wenigstens markieren */
      if (!label) return;
      const range = document.createRange();
      range.selectNodeContents(label);
      const selection = window.getSelection();
      selection?.removeAllRanges();
      selection?.addRange(range);
      return;
    }
    this.classList.add('is-copied');
    if (label) label.textContent = this.dataset.copied || text;
    window.clearTimeout(this.timer);
    this.timer = window.setTimeout(() => {
      this.classList.remove('is-copied');
      if (label) label.textContent = text;
    }, 2000);
  }
}

customElements.define('kg-copy', KgCopy);
